<template>
  <v-container
    id="order_archive"
    v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
    }"
    fluid
    tag="section"
    style="height: calc(100% - 110px)"
  >
    <base-material-card
      icon="mdi-eye-refresh"
      class="px-5 py-3"
      width="100%"
      title="Archivio Ordini WEB"
    >
      <!-- <v-row class="mt-4">
        <v-col
          cols="12"
        >
          <table
            v-if="cliente"
            class="text-h4 text-weigth-light"
          >
            <tr>
              <td class="text-no-wrap pr-3">
                Cliente
                <div v-if="isMobile">
                  {{ cliente.ragsoc }} {{ cliente.indiri_1 }}<br>
                  {{ cliente.indiri2 }} {{ cliente.locali }}
                </div>
              </td>
              <td v-if="!isMobile">
                {{ cliente.ragsoc }} {{ cliente.indiri_1 }}
              </td>
            </tr>
            <tr v-if="!isMobile">
              <td /><td>{{ cliente.indiri2 }} {{ cliente.locali }} </td>
            </tr>
          </table>
        </v-col>
      </v-row> -->
      <p class="mt-8 text-h4 text-weigth-light">
        Periodo:
      </p>
      <v-row
        no-gutters
        class="mt-6 justify-space-between"
      >
        <v-menu
          v-model="mnu_data_start"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="$formatDate(data_start).substring(0, 10)"
              label="Data Inizio"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="data_start"
            locale="it-IT"
            @input="mnu_data_start = false"
          />
        </v-menu>
        <v-menu
          v-model="mnu_data_end"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="$formatDate(data_end).substring(0, 10)"
              label="Data Fine"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="data_end"
            :allowed-dates="(val) => val >= data_start"
            locale="it-IT"
            @input="mnu_data_end = false"
          />
        </v-menu>
        <v-btn
          color="primary"
          @click="get_archivedOrders"
        >
          <v-icon>mdi-magnify</v-icon>
          Cerca
        </v-btn>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            v-if="listOrders"
            loading-text="Caricamento..."
            :loading="loading"
            :search="search"
            :items-per-page="-1"
            hide-default-footer
            :headers="headers"
            :items="listOrders"
            class="elevation-1"
          >
            <template v-slot:item.status_txt="{item}">
              <span v-html="item.status_txt" />
            </template>
            <template v-slot:item.action="{item}">
              <v-btn
                text
                @click="orderToPdf(item)"
              >
                <v-icon
                  large
                  color="red"
                >
                  mdi-file-pdf-box
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </base-material-card>

    <v-overlay :value="loading">
      <v-row
        style="width:50vw; position:fixed; left:30vw"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
  import Config from '@/config.js'

  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'

  export default {
    name: 'OrderArchive',
    components: {

    },
    data () {
      return {
        loading: false,
        cliente: null,
        codcli: null,
        search: null,
        valid: true,
        listOrders: false,
        showBackOnline: false,
        mnu_data_start: false,
        data_start: new Date((Date.now() - (new Date()).getTimezoneOffset() * 60000) - (90 * 24 * 60 * 60 * 1000)).toISOString().substring(0, 10),
        mnu_data_end: false,
        data_end: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),

        headers: [
          { text: 'Id_progre', value: 'WBOF_PROGRE' },
          { text: 'Data Ordine', value: 'WBOF_DATORD' },
          { text: 'Articolo', value: 'WBOF_CODART' },
          { text: 'Riferimento', value: 'WBOF_DESRIF' },
          { text: 'Stato', value: 'status_txt' },
          { text: '', value: 'action' },
        ],
      }
    },
    computed: {
      ...mapState(['auth', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
      config () {
        return Config
      },
    },
    watch: {
      onLine (v) {
        if (v) {
          this.showBackOnline = true
          setTimeout(() => {
            this.showBackOnline = false
          }, 1000)
        }
      },
    },
    mounted () {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)
      this.cliente = this.clidata.anacli
      var codsog = this.auth.userinfo.codsog
      var coddes = this.auth.userinfo.coddes.toString().padStart(3, '0')
      this.codcli = `${codsog}${coddes}`
      console.log('analisi codcli', this.codcli)
      this.get_archivedOrders()
    },
    beforeDestroy () {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    },
    methods: {

      swipe (direction) {
        if (direction === 'Left') {
          this.step++
        } else {
          this.step--
        }
      },
      updateOnlineStatus (e) {
        const { type } = e
        this.onLine = type === 'online'
      },
      get_archivedOrders () {
        this.loading = true
        engine.get_archivedOrders(this.codcli, this.data_start, this.data_end)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.listOrders = result.data
          })
          .catch((errore) => {
            console.log('search err: ', errore)
          }).finally(() => { this.loading = false })
      },

      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      onSubmit () {
        this.valid = this.$refs.form.validate()
        // if (this.valid) {
        //   console.log('send', this.lens)
        //   const data = { lens: this.lens, cliente: this.cliente }
        //   engine.sendRiparazione(data).then((result) => {
        //     if (result) {
        //       // alert('Form has been submitted!')
        //       console.log('sendRiparazione', result)
        //       this.$store.commit('setSnack', { message: 'Inviato ordine di riparazione', color: '#4caf50', timeout: 5000 })
        //     }
        //   })
        //     .catch((errore) => {
        //       // eslint-disable-next-line no-console
        //       console.error('ERR####', errore)
        //     })
        //   return
        // }
        // this.$store.commit('setSnack', { message: 'Inserire Dati Obbligatori', color: '#c54747d4', timeout: 8000 })
        // this.$vuetify.goTo(0) // scroll top
        // console.log('send invadlid', this.lens)

        // engine.sendOrder(this.lens, this.page).then((result) => {
        //   if (result) {
        //     // alert('Form has been submitted!')
        //     console.log('update newitem', result)
        //     this.$emit('updateItem', result)
        //     this.$emit('close')
        //   }
        // })
        //   .catch((errore) => {
        //     // eslint-disable-next-line no-console
        //     console.error('ERR####', errore)
        //     this.$store.commit('setSnack', { message: 'General Error', color: '#c54747d4' })
        //   })
      },
      orderToPdf (item) {
        var progre = item.WBOF_PROGRE
        var that = this
        var order
        engine.getOrderToPdf(progre)
          .then(result => {
            console.log('orderToPdf', result)
            if (!result.data?.steporder) {
              that.getPdfRequest(item, 'ordini_v0')
              return
            }
            order = JSON.parse(result.data.steporder)
            this.getPdfRequest(order, 'ordini_v4')
          })
      },

      getPdfRequest (item, ver) {
        this.loading = true
        engine.getPdf(item, ver)
          .then(result => {
            if (result) {
              // (C2) TO "FORCE DOWNLOAD"
              var url = window.URL.createObjectURL(result)
              var anchor = document.createElement('a')
              anchor.href = url
              anchor.target = '_blank'
              // anchor.download = obj.filename || `${this.page}.pdf`
              anchor.click()
              // // (C3) CLEAN UP
              // window.URL.revokeObjectURL(url)
              // document.removeChild(anchor)
            }
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
            }
            // this.$store.commit('setSnack', { message: 'PDF ok', color: '#4caf50' })
          })
          .catch((errore) => {
            console.log('api err: ', errore)
          }).finally(() => { this.loading = false })
      },
    },
  }

</script>
<style>
#riparazioni .bordered{
  border:1px solid #ccc;

}
</style>
